<!--
 * @Author: your name
 * @Date: 2021-02-24 14:43:00
 * @LastEditTime: 2024-10-29 11:31:28
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\index.vue
-->
<template>
  <div class="windows-index" v-loading="loading" :element-loading-text="$t('PE.SaveWait')"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <div class="c-u-left flex-b-c">
            <img class="icon" src="@/assets/images/public/public_return.png" @click="returnProgramManage" alt />
            <span style="padding-left: 16px; color: #617883; font-size: 16px">{{
              vdrInfor.name
            }}</span>
          </div>
          <div class="c-u-right" v-if="!(vdrInfor.type === 'look')">
            <el-dropdown style="margin-right: 18px" v-show="false">
              <el-button size="mini" round>
                节目模板
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>节目模板1</el-dropdown-item>
                <el-dropdown-item>节目模板1</el-dropdown-item>
                <el-dropdown-item>节目模板1</el-dropdown-item>
                <el-dropdown-item>节目模板1</el-dropdown-item>
                <el-dropdown-item>节目模板1</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="mini" round @click="addProgramDv = true">{{
              $t("PE.Setting")
            }}</el-button>
            <el-button size="mini" round @click="save" :disabled="!isSaveProgram">{{ $t("PE.Save") }}</el-button>
            <el-button size="mini" round @click="publish"
              :disabled="!(isSaveProgram === true && (vdrInfor.examine === 'false' || vdrInfor.examine === false || vdrInfor.examine === undefined))">{{
                $t("PE.Release") }}</el-button>
            <!-- <el-button size="mini" round @click="publish" :disabled="!isSaveProgram">发布</el-button> -->
            <!-- <img class="icon" src="./static/images/public/public_chart_sel.png" alt />
            <img class="icon" src="./static/images/public/public_save.png" alt />
            <img class="icon" src="./static/images/public/public_upload.png" alt />-->
          </div>
        </template>
        <template slot="center">
          <div class="program-window">
            <div class="program-list">
              <window-list></window-list>
            </div>
            <div class="program-vdr">
              <div class="vdr-tools">
                <vdr-tools></vdr-tools>
              </div>
              <div class="vdr-drawing">
                <vdr ref="vdrImage"></vdr>
              </div>
              <div class="vdr-split">
                <vdr-split></vdr-split>
              </div>
              <span class="percentage">
                <el-button class="button" @click="percentageUp" icon="el-icon-circle-plus-outline" round></el-button>
                <span>{{ percentage }}%</span>
                <el-button class="button" @click="percentageDown" :disabled="disabledDown" icon="el-icon-remove-outline"
                  round></el-button>
              </span>
              <span class="vdr-drawing-size">{{
                `${vdrInfor.w}x${vdrInfor.h}`
              }}</span>
            </div>
            <div class="program-attr">
              <attr></attr>
            </div>
          </div>
          <div class="program-material" v-if="!(vdrInfor.type === 'look')">
            <div class="pm-list">
              <trees type="FILELIST" @getAssets="getAssets" :list="fileList" :showTitle="false" :select="`${fileId}`">
              </trees>
            </div>
            <div class="pm-chile">
              <material-list :mediaList="mediaList" :current="current"
                @mediaListChange="mediaListChange"></material-list>
            </div>
          </div>
        </template>
      </enfold-uc>
    </enfold>
    <del-dialog :dialogVisible="returnDV" @closeDialog="returnCD" :title="$t('PE.Quit')">
      <div style="text-align: center">{{ $t("PE.ExitEditProgram") }}</div>
    </del-dialog>
    <terminal-list :terminalListDV="terminalListDV" @publishTerminal="publishTerminal"></terminal-list>
    <program-setting :addProgramDv="addProgramDv" @addProgramCd="addProgramCd"></program-setting>
  </div>
</template>

<script>
import trees from '@/components/basics/Trees'
import enfold from '@/components/basics/Enfold'
import EnfoldUc from '@/components/basics/EnfoldUC'
import vdr from './children/Vdr'
import VdrTools from './children/VdrTools'
import WindowList from './children/WindowList'
import Attr from './children/Attr'
import MaterialList from './children/MaterialList'
import { mPagination } from "@/components/basics/mixins"
import { dataFlattening, dataFold } from '@/assets/scripts/programData.js'
import { rgbaToHex, hexToRgba } from '@/assets/scripts/rgbaAndHex.js'
import html2canvas from "html2canvas"
import superClone from '@/assets/scripts/superClone.js'
import DelDialog from '@/components/basics/DelDialog'
import TerminalList from './children/TerminalList'
import ProgramSetting from "../children/ProgramSetting";
import toolsList from '@/assets/scripts/toolsList.js';
import { getOrganization } from "@/assets/scripts/publicFunction";
import { groupByTerminal } from "@/assets/scripts/publicFunction.js";
import VdrSplit from "./children/VdrSplit";


export default {
  name: 'MaterialCheck',
  mixins: [mPagination],
  provide() {
    return {
      vdrInfor: this.$route.query
    }
  },
  data() {
    // const toolsList = [
    //   { title: "文本", type: "4", image: "program_text.png" },
    //   { title: "数字时钟", type: "6", image: "program_numclock.png" },
    //   { title: "模拟时钟", type: "7", image: "program_imitateclock.png" },
    //   { title: "天气", type: "5", image: "program_weather.png" },
    //   { title: "正计时", type: "13", image: "program_positivetime.png" },
    //   { title: "倒计时", type: "12", image: "program_countdown.png" },
    //   { title: "流媒体", type: "14", image: "program_media.png" },
    //   { title: "RSS", type: "17", image: "program_Rss.png" },
    //   // { title: "日历", type: "11", image: "program_calendar.png" },
    // ];
    return {
      groupList: [],
      fileList: [],
      mediaList: [],
      loading: false,
      imgUrl: "",
      returnDV: false,
      vdrInfor: {},
      toolsList: toolsList(),
      saveStates: "",
      terminalListDV: false,
      programId: "",
      fileId: -1,
      addProgramDv: false,
      percentage: 90,
      disabledDown: false
    }
  },
  created() {
    this.vdrInfor = this.$route.query;
    const { type, groupId } = this.vdrInfor;
    this.groupId = groupId;
    // 清空所有节目编辑数据
    // this.$store.commit("VDR_LIST_CLEAR");
    switch (type) {
      case 'add': {
        // console.log(type);
      } break;
      case 'edit': {
        // 请求服务器节目编辑数据
        this.vdrListLength === 0 && this.$http.post("/admin/play/detail", { play_id: this.vdrInfor.id }, data => {
          let vdrList = data.object_json;
          setTimeout(() => {
            this.vdrInit(superClone(vdrList));
          }, 100);
        });
      } break;
      case 'look': {
        this.$http.post("/admin/play/detail", { play_id: this.vdrInfor.id }, data => {
          let vdrList = data.object_json;
          setTimeout(() => {
            this.vdrInit(superClone(vdrList));
          }, 100);
        });
      } break;
      default:
        break;
    }
    this.$http.post("/admin/material/mdList", {}, data => {
      this.fileList = data;
      this.$nextTick(() => {
        this.fileId = getOrganization(this.fileList, this.vdrInfor.groupId).id;
        this.getNewMediaList();
      })
    });
  },
  mounted() {
    // 工具图标初始化
    this.toolsList.forEach((tool) => {
      tool.image && (tool.image = require("@/assets/images/program/" + tool.image));
    });
  },
  methods: {
    addProgramCd() {
      this.addProgramDv = false;
    },
    vdrInit(vdrList) {
      // console.log(vdrList);
      vdrList.forEach((vdrItem) => {
        vdrItem.wicket.forEach((wicketItem, index) => {
          vdrItem.wicket[index] = this.wicketInit(dataFlattening(wicketItem));
        });
        this.$store.commit("VDR_LIST_ADD", vdrItem);
      });
    },
    returnProgramManage() {
      if (this.isSaveProgram && (this.vdrInfor.type !== 'look')) {
        this.returnDV = true;
      } else {
        this.$router.push({ name: 'ProgramManage' });
      }
    },
    returnCD(isConfirm) {
      if (isConfirm) {
        this.$store.commit("VDR_LIST_CLEAR");
        this.$router.push({ name: 'ProgramManage' });
      }
      this.returnDV = false;
    },
    publish() {
      this.saveStates = "publish";
      this.terminalListDV = true;
    },
    async publishTerminal(terminalList, adapter_screen, isAppend) {
      if (terminalList && terminalList.length > 0) {
        await this.getImage();

        let listGroup = groupByTerminal(terminalList, "main_device").map((group) => {
          const { list, main_device } = group;
          return { main_device, ids: list.map((d) => d.id) };
        });

        await this.$http.post(`/admin/publish/addNew`, {
          group_id: this.$cookies.get('group_id'),
          play_ids: this.programId,
          list_group: encodeURIComponent(JSON.stringify(listGroup)),
          play_mode: 0,
          publish_strategy: 0,
          publish_type: 1,
          isAppend: isAppend,
          adapter_screen: adapter_screen ? 1 : 0
        }, () => {
          // 节目发布成功，跳转到节目列表
          this.$http.post("/admin/Command/getDownloadList", {}, res => {
            this.$store.commit("ISSUE_LIST", res);
          });
        });
        await this.$msg({ showClose: true, message: '节目发布成功！', type: 'success' });
        await this.$router.push({ name: 'ProgramManage', params: {} });

        // await this.getImage();
        // const list = groupByTerminal(terminalList, 'main_device')
        // list.forEach(async (item) => {
        //   let data = {
        //     group_id: this.$cookies.get('group_id'),
        //     play_ids: this.itemProgram.id,
        //     main_device: item.main_device,
        //     device_ids: item.list.map(terminal => terminal.id).join(","),
        //     play_mode: 0,
        //     publish_strategy: 0,
        //     publish_type: 1,
        //     isAppend: isAppend,
        //     adapter_screen: adapter_screen ? 1 : 0
        //   }
        //   await this.$http.post(`/admin/publish/add`, data, () => {
        //     // 节目发布成功，跳转到节目列表
        //     this.$http.post("/admin/Command/getDownloadList", {}, data => {
        //       this.$store.commit("ISSUE_LIST", data);
        //     });
        //   });
        //   await this.$msg({ showClose: true, message: '节目发布成功！', type: 'success' });
        //   await this.$router.push({ name: 'ProgramManage', params: {} });
        // });
        // let data = {
        //   group_id: this.vdrInfor.groupId,
        //   play_ids: this.programId,
        //   device_ids: terminalList.map(terminal => terminal.id).join(","),
        //   play_mode: 0,
        //   publish_strategy: 0,
        //   publish_type: 1,
        //   isAppend: isAppend,
        //   adapter_screen: adapter_screen ? 1 : 0
        // }
        // this.$http.post(`/admin/publish/add`, data, () => {
        //   // 节目发布成功，跳转到节目列表
        //   this.$msg({ showClose: true, message: '节目发布成功！', type: 'success' });
        //   this.$http.post("/admin/Command/getDownloadList", {}, data => {
        //     this.$store.commit("ISSUE_LIST", data);
        //   });
        //   this.$router.push({
        //     name: 'ProgramManage',
        //     params: {}
        //   });
        // });
      }
      this.terminalListDV = false;
    },
    save() {
      this.saveStates = "save";
      this.getImage();
    },
    getImage() {
      this.loading = true;
      this.$store.commit("IS_SAVE_PROGRAM", true);
      return new Promise((resolve) => {
        setTimeout(() => {
          html2canvas(this.$refs.vdrImage.$el, {
            useCORS: true,
            scale: 0.1
          }).then(async (canvas) => {
            let dataURL = canvas.toDataURL("image/png");
            this.imgUrl = dataURL;
            if (this.imgUrl) {
              this.$store.commit("IS_SAVE_PROGRAM", false);
              await this.saveProgramList();
              this.loading = false;
              resolve();
            }
          });
        }, 100);
      });
    },
    async saveProgramList() {
      let data = {
        size_remark: `${this.vdrInfor.w}x${this.vdrInfor.h}`,
        name: this.vdrInfor.name,
        group_id: this.vdrInfor.groupId,
        object_json: encodeURIComponent(JSON.stringify(this.programFormatting())),
        pimg: this.imgUrl
      }
      this.vdrInfor.id && (data.id = this.vdrInfor.id)
      await this.saveProgram(data);
    },
    // 保存节目
    async saveProgram(data) {
      await this.$http.post(`/admin/play/${this.vdrInfor.type}`, data, (data) => {
        switch (this.saveStates) {
          case 'save': {
            // 节目发布成功，跳转到节目列表
            this.$router.push({
              name: 'ProgramManage',
              params: {}
            });
          } break;
          case 'publish': {
            this.programId = data.play_id;
          } break;
          default:
            break;
        }
      });
    },
    // 发布节目
    publishProgram() {

    },
    // 节目列表数据格式化
    programFormatting() {
      let vdrList = superClone(this.vdrList);
      vdrList.forEach((vdrItem) => {
        vdrItem.wicket.forEach((wicketItem, index) => {
          let wicket = dataFold(this.dateSync(wicketItem));
          vdrItem.wicket[index] = wicket;
        });
      });
      return vdrList;
    },
    // 数据同步
    dateSync(wicket) {
      // 播放时长设置
      wicket.ext_val_duration = wicket.ext_val_duration * 1000;
      // 进入时间初始化
      if (wicket.ext_val_enterTime !== undefined) {
        wicket.ext_val_enterTime = wicket.ext_val_enterTime * 1000;
      }
      // 时间格式化
      if (wicket.type === '12' || wicket.type === '13') {
        wicket.ext_val_absoluteTime = parseInt(wicket.ext_val_absoluteTime.getTime() / 1000);
      }
      // 保持比例格式化
      if (wicket.ext_val_scaleType !== undefined) {
        wicket.ext_val_scaleType = wicket.ext_val_scaleType ? 0 : 1;
      }
      // pimg属性设置
      let isUpPimg = { '1': true, '2': true, }
      !isUpPimg[wicket.type] && (wicket.ext_val_pimg = "");
      // 颜色转化到hex
      for (let key in wicket) {
        let regexp = /(?<=\()(\d+),(\d+),(\d+),((?:0?\.\d+)|1|0)(?=\))/;
        let wicketVal = wicket[key];
        if (typeof (wicketVal) === 'string' && regexp.test(wicketVal.replace(/\s+/g, ""))) {
          let rgba = wicketVal.replace(/\s+/g, "");
          wicket[key] = rgbaToHex(rgba).hex10;
        }
      }
      return wicket;
    },
    // 数据解析
    wicketInit(wicket) {
      // 初始化播放时长
      const { type } = wicket;
      if (type == '1') {
        wicket.ext_val_duration = wicket.ext_val_duration / 1000;
      } else {
        wicket.ext_val_duration = parseInt(wicket.ext_val_duration / 1000);
      }
      // 进入时间初始化
      if (wicket.ext_val_enterTime !== undefined) {
        wicket.ext_val_enterTime = parseInt(wicket.ext_val_enterTime / 1000);
      }
      // 时间格式化
      if (wicket.type === '12' || wicket.type === '13') {
        wicket.ext_val_absoluteTime = new Date(wicket.ext_val_absoluteTime * 1000);
      }
      // 初始化颜色设置
      for (let key in wicket) {
        if (/Color?$/.test(key)) {
          wicket[key] = hexToRgba(wicket[key]);
        }
      }
      // 保持比例格式化
      if (wicket.ext_val_scaleType !== undefined) {
        wicket.ext_val_scaleType = wicket.ext_val_scaleType === 1 ? false : true;
      }
      // 初始化工具图标
      let isUpPimg = { '1': true, '2': true, }
      if (!isUpPimg[wicket.type]) {
        let tool = this.toolsList.find((tool) => tool.type === wicket.type);
        wicket.ext_val_pimg = tool.image
      }
      //
      // console.log(wicket);
      return wicket;
    },
    getAssets(ids) {
      // console.log(ids);
      // if (ids.type === "GROUP") {
      //   this.groupIds = ids.ids
      // }
      if (ids.type === "FILELIST") {
        this.groupId = ids.groupId;
        this.fileId = ids.id;
      }
      this.page = 1;
      this.current = 0;
      this.mediaList = [];
      this.getNewMediaList();
    },
    // getMediaList(media = {
    //   limit: this.limit,
    //   group_ids: this.groupIds,
    //   dir_id: this.dirId,
    //   page: this.page,
    // }) {
    //   this.$http.post("/admin/material/list", media, data => {
    //     // console.log(data);
    //     if (data.list && data.list.length > 0) {
    //       this.mediaList = this.mediaList.concat(data.list);
    //       this.page += 1;
    //     } else {
    //       this.$msg({ showClose: true, message: '已加载全部资源！', type: 'warning' });
    //     }
    //   });
    // },
    getNewMediaList(media = {
      dir_id: this.fileId,
      limit: this.limit,
      group_ids: this.groupId,
      page: this.page,
      material_state: "2,-1"
    }) {
      this.$http.post("/admin/material/list", media, data => {
        if (data.data && data.data.length > 0) {
          this.mediaList = this.mediaList.concat(data.data);
          // this.mediaList.forEach(media => {
          //   media['key'] = Math.random();
          // });
          this.current = data.total;
        } else {
          // this.$msg({ showClose: true, message: '已加载全部资源！', type: 'warning' });
        }
      });
    },
    mediaListChange() {
      setTimeout(() => {
        if (this.mediaList.length < this.current) {
          this.page += 1;
          this.getNewMediaList();
        }
      }, 1000);
    },
    percentageUp() {
      this.disabledDown = false;
      const oldRatio = this.ratio / this.percentage * 100;
      const pert = this.percentage += 5;
      const newRatio = oldRatio * pert / 100;
      this.$store.commit("RATIO_COUNT", newRatio);

    },
    percentageDown() {
      this.percentage === 10 && (this.disabledDown = true);
      const oldRatio = this.ratio / this.percentage * 100;
      const pert = this.percentage -= 5;
      const newRatio = oldRatio * pert / 100;
      this.$store.commit("RATIO_COUNT", newRatio);
    },
  },
  components: {
    enfold,
    EnfoldUc,
    vdr,
    VdrTools,
    WindowList,
    Attr,
    MaterialList,
    trees,
    DelDialog,
    TerminalList,
    ProgramSetting,
    VdrSplit
  },
  computed: {
    ratio() {
      return this.$store.state.program.ratio;
    },
    vdrListLength() {
      return this.$store.getters.getVdrListLength;
    },
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    isSaveProgram() {
      return this.vdrListLength > 0 && this.vdrList.some((vdrItem) => vdrItem.wicket.length > 0);
    }
  }
  // watch: {
  //   vdrList: {
  //     handler() {
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.windows-index {
  width: 100%;
  height: 100%;

  /deep/ .center {
    display: flex;
    flex-direction: column;

    .program-window {
      flex: 1;
      display: flex;
      overflow: auto;

      .program-list {
        flex: 0 0 18%;
        min-width: 240px;
        max-width: 280px;
        // background-color: red;
      }

      .program-vdr {
        flex: 1;
        overflow: auto;
        display: flex;
        flex-direction: column;
        position: relative;

        .vdr-tools {
          flex: 0 0 40px;
        }

        .vdr-drawing {
          flex: 1;
          // 画布居中
          display: flex;
          justify-content: center;
          align-items: center;
          // end
          overflow: auto;
          border-left: 1px solid #d7ecf3;
          border-right: 1px solid #d7ecf3;
        }

        .percentage {
          position: absolute;
          right: 0px;
          bottom: 32px;
          font-size: 14px;
          color: #617883;
          z-index: 999;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .button {
            padding: 0;
            border: 0;
            margin: 8px 0;
            font-size: 18px;
          }
        }

        .vdr-drawing-size {
          position: absolute;
          right: 12px;
          bottom: 10px;
          font-size: 16px;
          color: #617883;
          pointer-events: none;
          z-index: 999;
        }

        .vdr-split {
          position: absolute;
          right: 0;
          top: 40px;
        }
      }

      .program-attr {
        flex: 0 0 18%;
        min-width: 240px;
        max-width: 280px;
        // background-color: red;
      }
    }

    .program-material {
      flex: 0 0 18%;
      min-width: 240px;
      display: flex;

      .pm-list {
        flex: 0 0 18%;
        min-width: 240px;
        max-width: 280px;
        max-height: 240px;
        background-color: #fff;
        border-top: 1px solid #d7ecf3;

        .trees {
          width: 100%;
          height: 100%;

          .trees-content {
            height: 100%;
          }
        }
      }

      .pm-chile {
        max-height: 240px;
        width: calc(100% - 240px);
        // background-color: blue;
      }
    }
  }

  .c-u-right {
    display: flex;

    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }

    /deep/ .el-input__suffix {
      line-height: 30px;
      color: #2fb3ff;
      font-size: 16px;
      right: 10px;
    }

    .el-button+.el-button {
      margin-left: 18px;
    }

    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }
}

@media screen and (min-width: 1200px) {
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: rgba(240, 240, 240, 1);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 0px rgba(53, 202, 250, 0.3);
    background-color: rgba(53, 202, 250, 0.3);
  }
}
</style>
<style>
.app-body {
  height: 100%;
}
</style>